export const INITIAL_TIMESHEET_FETCH = "INITIAL_TIMESHEET_FETCH";
export const SET_TIMESHEET_FILTERS = "SET_TIMESHEET_FILTERS";
export const SET_TIMESHEET_PAGE = "SET_TIMESHEET_PAGE";
export const SET_TIMESHEET_SEARCH = "SET_TIMESHEET_SEARCH";
